import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { ConventionCenterDialogComponent } from './dialogs/convention-center-dialog/convention-center-dialog.component';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import {ConventionCenterService} from '../services/convention-center.service';
import {ConventionCenter} from '../models/convention-center';

@Component({
  selector: 'app-convention-center',
  templateUrl: './convention-center.component.html',
  styleUrls: ['./convention-center.component.scss'],
  entryComponents: [
    ConventionCenterDialogComponent
  ]
})
export class ConventionCenterComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = ['icon', 'name', 'edit', 'delete'];

  constructor(
    private _conventionCenterService: ConventionCenterService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _authService: AuthService,
    private router: Router) {

    if (!this._authService.isAdmin) {
      this.router.navigate(['home']);
    }

    this.loadConventionCenters()
  }

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.sub)
      this.sub.unsubscribe();
  }

  loadConventionCenters() {

    this.sub = this._conventionCenterService.select()
      .subscribe((result) => {

        let array = result.map(item => {
          let entity = new ConventionCenter();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.city = item.payload.doc.data().city;
          entity.state = item.payload.doc.data().state;
          entity.address = item.payload.doc.data().address;
          entity.rooms = item.payload.doc.data().rooms;
          entity.deleted = item.payload.doc.data().deleted;
          return entity;
        });

        setTimeout(() => {
          this.dataSource = new MatTableDataSource(array);
          this.dataSource.sort = this.sort;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })

  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(entity) {

    let data: ConventionCenter = new ConventionCenter();

    if (entity) {
      data = entity;
    }

    this.dialog.open(ConventionCenterDialogComponent, {
      width: '800px',
      height: '550px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }


  delete(element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.name + "<br><br>Excluir este Centro de Convenção?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._conventionCenterService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete regional error: " + error.message) }
          )
      }
    })
  }

}

